var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsVx = function SvgNotificationsVx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18.646 4.064a.998.998 0 0 1 1.148.328 1.005 1.005 0 0 1 .142.962l-5.993 16.979a1 1 0 0 1-1.85.09l-3.345-7.17-7.17-3.347a1 1 0 0 1 .09-1.85l16.978-5.992zm-7.944 10.648l2.17 4.648L16.59 8.824l-5.888 5.888zm-1.414-1.414l5.888-5.888L4.64 11.13l4.648 2.169z"
  })));
};
export default SvgNotificationsVx;